// App-wide configuration constants

export const AI_API = 'https://ndb4d1r8u9.execute-api.us-east-1.amazonaws.com/dev/story';
export const ADMIN_USER_ID = 'a45844e8-90e1-705d-ad4e-9fdcd65c62cc';
export const ORDER_API_BASE = 'https://5nrm0mndm9.execute-api.us-east-1.amazonaws.com/prod';
export const STRIPE_PK = 'pk_live_51TXPdCQVqPRbIz1LB2UltiPii9HCQbhCEOu8ex9ResOFpa4dw4xrRqZRPHV0EnDzChLkQl67DY5HxNxa2PYSeIrI00792AoRlX';
// Cloudflare Turnstile site key — PUBLIC (embedded in the signup form), safe to commit. TB-115.
export const TURNSTILE_SITE_KEY = '0x4AAAAAADtdxk_PHU8aX90H';
export const TOPAZ_API_BASE = 'https://j633lx7mcxga6qrgvyu2v7sm7a0xrpkw.lambda-url.us-east-1.on.aws';

// Memory Care kill-switch (F-12, per docs/MEMORY-CARE-AUDIT.md §6). While FALSE, every
// Memory Care doorway shows the "coming soon" placeholder + interest sensor instead of the
// (unreviewed, safety-gapped) interview engine. Reversal = flip to true after the audit's
// return-contract battle ships. Lives here (shared/importable) rather than App.js-local
// because it is read across App.js + BookBuilderPage + StWritePage. Mirrors KID_MODE_ENABLED.
export const MEMORY_CARE_ENABLED = false;
